import React from "react"
import { FastField } from "formik"
import FormError from "../components/formError"

const CustomInput = ({ label, name, type, touched, errors, className }) => {
  return (
    <div className={`form-group  ${className}`}>
      <label htmlFor={name}>{label}</label>
      <FastField type={type} className="form-control" id={name} name={name} />
      <FormError touched={touched[name]} message={errors[name]} />
    </div>
  )
}
export default CustomInput
